import React from "react"

export default function BplsSignatureIcon(props) {
  const {
    viewBox = "0 0 947.000000 858.000000",
    fill = "#000000",
    width = "947.000000pt",
    height = "858.000000pt"
  } = props
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g transform="translate(0.000000,858.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
        <path
          d="M7410 8430 c-41 -11 -108 -39 -149 -63 -67 -38 -343 -312 -2963
-2934 -1590 -1590 -2900 -2906 -2913 -2925 -20 -30 -38 -85 -110 -343 -30
-105 -218 -758 -290 -1005 -32 -107 -67 -231 -80 -275 -12 -44 -50 -176 -85
-294 -67 -231 -69 -255 -31 -330 25 -47 66 -88 115 -113 58 -30 158 -21 321
30 72 22 195 59 275 82 80 23 213 61 295 85 134 40 614 178 990 286 77 22 187
54 245 71 l105 31 1514 1516 c4408 4414 4303 4308 4348 4396 46 90 58 127 73
237 13 90 0 215 -30 304 -45 129 -84 175 -574 664 -500 500 -545 538 -681 576
-96 26 -284 28 -375 4z m247 -471 c31 -11 897 -869 917 -909 21 -41 27 -89 15
-135 -9 -36 -40 -73 -213 -249 -111 -113 -204 -206 -207 -206 -5 0 -939 933
-1079 1076 -8 8 394 406 425 420 36 16 103 18 142 3z m-374 -1305 c293 -294
532 -539 532 -544 0 -5 -1081 -1091 -2403 -2414 l-2403 -2404 -539 541 -539
542 237 239 c935 943 4567 4576 4574 4576 5 0 249 -241 541 -536z m-5153
-5167 c307 -309 411 -420 401 -426 -7 -5 -43 -16 -80 -26 -36 -9 -124 -34
-196 -55 -71 -21 -195 -57 -275 -80 -80 -23 -197 -57 -260 -76 -192 -57 -355
-102 -358 -100 -2 3 14 62 115 406 25 85 53 184 63 220 14 51 131 460 156 543
3 10 9 17 12 15 4 -2 194 -191 422 -421z"
        />
      </g>
    </svg>
  )
}
